module.exports = __webpack_public_path__ + "static/media/S (183).047d2b00.jpg";